import { Radio } from '@/components'

import { AvailableServices } from '..'

import styles from './RadioSelector.module.scss'

export const RadioSelector = ({ control, name, options }) => {
  return (
    <div className={styles.radioSelector__options}>
      {options.map(({ value, label, available_services }) => (
        <div className={styles.radioSelector__option} key={`${name}-${value}`}>
          <Radio name={name} label={label} value={value} control={control} />

          {available_services && (
            <AvailableServices
              id={`${name}-${value}`}
              services={available_services}
            />
          )}
        </div>
      ))}
    </div>
  )
}
